import { useEffect, useState } from 'react'

/**
 * 短暂提示文案：设置后过 ttl 毫秒自动清空（默认 4 秒）。
 *
 * 用在「操作反馈」上（报错、成功提示）：显示一下就应该消失，
 * 不该让用户退出页面再进来才清掉。页面状态类文案（比如「整页加载失败」）
 * 不要用这个 hook。
 */
export function useTransientText(ttl = 4000) {
  const [text, setText] = useState('')
  useEffect(() => {
    if (!text) return
    const timer = window.setTimeout(() => setText(''), ttl)
    return () => window.clearTimeout(timer)
  }, [text, ttl])
  return [text, setText] as const
}
